import { useContext, useMemo } from "react";
import { WorkoutContext } from "../../contexts/WorkoutContext";
import { useAuth } from "../../contexts/AuthContext";
import { useUserProfile } from "../../contexts/UserProfileContext";
import useTrainingLoad from "../../hooks/useTrainingLoad";
import useSessionAnalysis from "./useSessionAnalysis";
import { useVo2max } from "../profile/CardioSheets";
import { estimateFtp } from "../../utils/progress";

/**
 * Everything the Progress page and Activity's Progress card show (#203):
 * training load and fitness, VO2max, the per-session analysis and FTP.
 * `refresh` re-reads the training load (see useTrainingLoad).
 */
export default function useProgress(refresh) {
  const { userProfile } = useContext(WorkoutContext);
  const { isAuthenticated } = useAuth();
  const { profile: cloudProfile, performanceCapabilities = [] } = useUserProfile();
  const { loads, fitness } = useTrainingLoad(refresh);
  const { rows, loading } = useSessionAnalysis();
  const vo2max = useVo2max({
    signedIn: isAuthenticated,
    userProfile,
    benchmarks: isAuthenticated ? performanceCapabilities : [],
    sex: cloudProfile?.training_data?.sex || null,
  });
  const ftp = useMemo(() => estimateFtp(rows), [rows]);
  return { loads, fitness, rows, loading, vo2max, ftp, userProfile, isAuthenticated };
}
